import { TableSchema, Query } from './types';
import { TableRef } from './engine';

/**
 * Different types of view sources
 * @memoryUsage View sources are lightweight references but point to:
 * - Potentially large tables
 * - Complex queries that may create large result sets
 */
export type ViewSource = 
  | { type: 'table'; tableRef: TableRef }
  | { type: 'query'; tableRef: TableRef; query: Query };

/**
 * Represents a view of a table that can be materialized by an engine
 * @memoryUsage Views are lightweight until materialized:
 * - View definition is just metadata
 * - Materialization can create large in-memory datasets
 * - Query views may generate large intermediate results
 */
export interface TableView {
  /**
   * The schema of the view
   */
  readonly schema: TableSchema;

  /**
   * Information about how to materialize this view
   */
  readonly source: ViewSource;
}

/**
 * Base implementation of TableView that can be extended by specific runtimes
 * @memoryUsage Same characteristics as TableView interface
 */
export class BaseTableView implements TableView {
  constructor(
    readonly schema: TableSchema,
    readonly source: ViewSource
  ) {}
} 